import { Skeleton, SkeletonItem, makeStyles } from "@fluentui/react-components";
import * as React from "react";

const useStyles = makeStyles({
  dropdown: {
    minWidth: "100px",
  },
});

export const PromptFiltersSkeleton: React.FC = () => {
  const styles = useStyles();
  return (
    <Skeleton aria-label="Loading Content">
      <SkeletonItem className={styles.dropdown} size={32} />
    </Skeleton>
  );
};
